import { SupportedLanguages } from "integration/api/models";

export const getLanguageTitle = (lng: SupportedLanguages) => {
  switch (lng) {
    case SupportedLanguages.EN:
      return "English";
    case SupportedLanguages.UK:
      return "Ukrainian";
    case SupportedLanguages.RU:
      return "Russian";
  }
};
